import { jsx as _jsx } from "react/jsx-runtime";
var PlayCircle = function PlayCircle(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.5 14.6V9.4l2.809 2.6-2.809 2.6Zm.839-7.147a1.709 1.709 0 0 0-1.851-.307c-.61.266-.988.835-.988 1.484v6.74c0 .65.378 1.219.988 1.485.223.098.46.145.693.145.423 0 .838-.155 1.157-.451l3.642-3.37a1.61 1.61 0 0 0 .52-1.18c0-.442-.189-.872-.52-1.177l-3.641-3.37ZM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8Zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Z",
      fill: color
    })
  });
};
export default PlayCircle;